import organization_dept_list from './dept-list';
import organization_dept_add from './dept-add';
import organization_dept_edit from './dept-edit';
import organization_dept_detail from './dept-detail';

export default {
    organization_dept_list,
    organization_dept_add,
    organization_dept_edit,
    organization_dept_detail,
};
